import { useEffect, useState } from "react";
import Hosts from "../pages/Hosts";
import Settings from "../pages/Settings";
import About from "../pages/About";
import ManageGateways from "../pages/ManageGateways";
import AddGateway from "../pages/AddGateway";
import { useSelector, useDispatch } from "react-redux";
import { initializeGateway } from "../redux/slices/gatewaysSlice";
import { getAllGateways } from "../services/gatewayService";
import { getGatewayStatus } from "../services/statusService";
import { fetchRecipients } from "../services/recipientService";

const MainContainer = ({ isMobile, isNavbarCollapsed, toggleNavbarCollapse, setIsToggleButtonHidden }) => {
  const activeComponent = useSelector(state => state.auth.activeComponent);
  const dispatch = useDispatch();

  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  const fetchGateways = async () => {
    const fetchedGateways = await getAllGateways();
    if (!Array.isArray(fetchedGateways)) {
      console.warn("Expected an array of gateways, got:", fetchedGateways);
      return;
    }
    const updatedGateways = await Promise.all(
      fetchedGateways.map(async gateway => {
        const gatewayStatus = await getGatewayStatus(gateway.id);
        const recipients = await fetchRecipients(gateway.id);

        return {
          ...gateway,
          gatewayStatus: gatewayStatus ? gatewayStatus : null,
          recipients: recipients,
        };
      }),
    );

    dispatch(initializeGateway(updatedGateways));
  };

  useEffect(() => {
    fetchGateways();
    const pollingInterval = parseInt(window.env.GATEWAY_POLL_TIME, 10);
    const intervalId = setInterval(() => {
      fetchGateways();
    }, pollingInterval);

    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case "AddGateway":
        return <AddGateway />;
      case "ManageGateways":
        return <ManageGateways isMobile={isMobile} />;
      case "Hosts":
        return (
          <Hosts
            isMobile={isMobile}
            toggleNavbarCollapse={toggleNavbarCollapse}
            setIsToggleButtonHidden={setIsToggleButtonHidden}
          />
        );
      case "Settings":
        return <Settings isMobile={isMobile} />;
      case "About":
        return <About />;
      default:
        return <ManageGateways />;
    }
  };

  const handleSwipe = () => {
    if (!isMobile) return;
    if (touchStartX === null || touchEndX === null) return;

    const distance = touchEndX - touchStartX;
    const threshold = 30;
    const edgeLimit = 80;

    if (distance > threshold && isNavbarCollapsed && touchStartX <= edgeLimit) {
      toggleNavbarCollapse();
    }

    if (distance < -threshold && !isNavbarCollapsed) {
      toggleNavbarCollapse();
    }

    setTouchStartX(null);
    setTouchEndX(null);
  };

  return (
    <div
      {...(isMobile && {
        onTouchStart: e => setTouchStartX(e.touches[0].clientX),
        onTouchMove: e => setTouchEndX(e.touches[0].clientX),
        onTouchEnd: handleSwipe,
      })}
      className={`w-full transition-all duration-300 ease-in-out ${isNavbarCollapsed ? "lg:ml-0" : "lg:ml-[240px]"}`}
    >
      {renderActiveComponent()}
    </div>
  );
};

export default MainContainer;
